export default [
  {
    title: "Point Exchange",
    customIcon: "PrivilegeSVG",
    children: [
      {
        title: "Upload Point",
        route: "upload-point",
        path: "/point-exchange/upload-point/upload-point-list",
      },
    ],
  },
];
